import { Pipe, PipeTransform } from '@angular/core';
import { TimeZoneService } from 'src/app/services/timezone.service';

@Pipe({name: 'cpdtime'})

export class CPDtime implements PipeTransform {

  // TimeZone related configuration
  public USATimeZone:boolean = true;

  constructor(private timezoneService: TimeZoneService) {
    this.USATimeZone = this.timezoneService.checkUSATimeZone();
  }

  transform(value: number): string {
    let prefix = 'CE';
    if (!this.USATimeZone) prefix = 'CPD';

    if(value<60){
      return prefix+' '+value+'m';
    }

    var hours = (value / 60);
    var rhours = Math.floor(hours);
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes);

    return prefix+' '+rhours+'h '+rminutes+'m';
  }
}